<script lang="ts">
import { parseLinks } from '$lib/utils/parseLinks';
import { stripSiteDomain } from '$lib/utils/url.js';
import Link from '../../atoms/Link/Link.svelte';

interface Props {
    title?: string;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    link1?: string;
    linkText1?: string;
    link2?: string;
    linkText2?: string;
    hideBlock?: boolean;
}

let {
    title = '',
    headingLevel = 'h2',
    link1 = '',
    linkText1 = 'Learn More',
    link2 = '',
    linkText2 = 'Learn More',
    hideBlock = false,
}: Props = $props();

// Transform URLs from Builder.io
const transformedLink1 = $derived(stripSiteDomain(link1));
const transformedLink2 = $derived(stripSiteDomain(link2));
</script>

{#if !hideBlock}
    <div class="text-callout">
        {#if title}
            <svelte:element this={headingLevel} class="text-callout__text">{@html parseLinks(title)}</svelte:element>
        {/if}
        {#if transformedLink1 || transformedLink2}
            <div class="text-callout__ctas">
                {#if transformedLink1}
                    <Link
                        to={transformedLink1}
                        type="link"
                        class="button button--inverse"
                    >
                        {#snippet text()}
                            {linkText1}
                        {/snippet}
                    </Link>
                {/if}
                {#if transformedLink2}
                    <Link
                        to={transformedLink2}
                        type="link"
                        class="button button--inverse"
                    >
                        {#snippet text()}
                            {linkText2}
                        {/snippet}
                    </Link>
                {/if}
            </div>
        {/if}
    </div>
{/if}

<style lang="scss">
    @use "/src/scss/global-constants/typography";
    @use "/src/scss/mixins/builder-rich-text" as builder-mixins;
    @use "sass-mq/mq" as *;

    .text-callout {
        align-items: center;
        display: flex;
        flex-direction: column;
        gap: var(--layout-pagegrid-gutter);
        justify-content: center;
        padding-left: var(--layout-pagegrid-margin);
        padding-right: var(--layout-pagegrid-margin);

        &__text {
            max-width: 75ch;
            text-align: center;
            text-wrap: balance;
            @include typography.text-callout;

            @include builder-mixins.rich-text-links;

            :global(strong) {
                font-weight: inherit;
            }
        }

        &__ctas {
            display: flex;
            gap: 4.4rem;
        }
    }
</style>
